export const addSingleMarkers = ({
  map,
  location
}: {
  location: google.maps.LatLngLiteral
  map: google.maps.Map | null | undefined
}) => {
  const marker = new google.maps.Marker({
    position: location,
    map,
    icon: '/images/marker.svg'
  })

  return marker
}
